import React from 'react'
import classes from './CommonText.module.scss';

function CommonText(props) {
    return (
        <div title={props?.children} className={`${classes['text']} ${props?.className}`} style={{...props?.style}}>{props?.children}</div>
    )
}

export default CommonText